import * as yup from 'yup';

export const validationSchema = yup.object().shape({
    slotName: yup
        .string()
        .required('Required'),
    sequence: yup
        .number()
        .typeError("Only number")
        .required('Required')
        .test(
            "is-positive",
            "Please enter a positive number",
            (value) => value >= 0 && 1 / value !== -Infinity),
})

export const initialValues = {
    slotName: "",
    slotId: "",
    sequence: "",
    status: true,
    defaultStatus: false
}